import { render, staticRenderFns } from "./DocumentPayHeader.vue?vue&type=template&id=1659ae80&scoped=true&"
import script from "./DocumentPayHeader.vue?vue&type=script&lang=js&"
export * from "./DocumentPayHeader.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPayHeader.vue?vue&type=style&index=0&id=1659ae80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1659ae80",
  null
  
)

export default component.exports